module.exports = __webpack_public_path__ + "static/media/card-email-es.f0dc076f.png";